
// Get index of product in JSON
function getProductObjIndex(handle) {
  for (i = 0; i < rvProducts.length; i++) {
    if (rvProducts[i].handle == handle) {
      return i;
    }
  }
}
